import MediaDatatable from '@/components/CustomDatatable/MediaDatatable/MediaDatatable';
import { MediaTypeEnum } from '@/models/Media';
import { Component, Ref, Vue } from 'vue-property-decorator';

@Component<PurchaseOrderAttachments>({})
export default class PurchaseOrderAttachments extends Vue {

  // #region @Props

  @Ref()
  protected mediaDatatable!: MediaDatatable;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected mediaType: MediaTypeEnum = MediaTypeEnum.PURCHASE_ORDER;

  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers

  // #endregion


  // #region API Requests
  // #endregion

  // #region Getters & Setters

  protected get mediaId(): string {
    return this.$route.params.id;
  }

  // #endregion

  // #endregion

  // #region @Watchers
  // #endregion
}
